import ListBlock from './ListBlock.vue';

export default ListBlock;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/list/index.ts